// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qj5ZU","top":"styles_top__2v_EK"};